import React, { CSSProperties, ReactNode, useEffect } from "react";
import { MapContainer, useMap } from "react-leaflet";
import L, { LatLngExpression } from 'leaflet';
import '@maplibre/maplibre-gl-leaflet';
import 'leaflet/dist/leaflet.css';
import 'maplibre-gl/dist/maplibre-gl.css';
import iconUrl from 'leaflet/dist/images/marker-icon.png';
import iconRetinaUrl from 'leaflet/dist/images/marker-icon-2x.png';
import shadowUrl from 'leaflet/dist/images/marker-shadow.png';

// Íconos de Leaflet servidos desde el propio paquete (se configuran una sola vez)
// @ts-ignore: propiedad interna de Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({ iconRetinaUrl, iconUrl, shadowUrl });

type MapStyle = "positron" | "bright" | "liberty" | "dark" | "fiord";

const ATTRIBUTION = '<a href="https://openfreemap.org">OpenFreeMap</a> &copy; <a href="https://www.openmaptiles.org/">OpenMapTiles</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>';

// Mapa base vectorial gratuito de OpenFreeMap (sin API key)
const BaseMapLayer = ({ mapStyle }: { mapStyle: MapStyle }) => {
    const map = useMap();

    useEffect(() => {
        const layer = L.maplibreGL({ style: `https://tiles.openfreemap.org/styles/${mapStyle}` });
        layer.addTo(map);
        // Los tipos del plugin no aceptan "attribution"; se agrega directo al control del mapa
        map.attributionControl?.addAttribution(ATTRIBUTION);
        return () => {
            map.removeLayer(layer);
            map.attributionControl?.removeAttribution(ATTRIBUTION);
        };
    }, [map, mapStyle]);

    return null;
};

type MapProps = {
    children?: ReactNode;
    center: LatLngExpression;
    zoom: number;
    scrollWheelZoom?: boolean;
    style?: CSSProperties;
    mapStyle?: MapStyle;
    onClick?: unknown; // se recibía antes pero nunca se usó; se mantiene para no romper a quien lo pase
};

const Map = ({ children, center, zoom, scrollWheelZoom, style, mapStyle = "positron" }: MapProps) => (
    <MapContainer
        center={center}
        zoom={zoom}
        scrollWheelZoom={scrollWheelZoom}
        style={style}
    >
        <BaseMapLayer mapStyle={mapStyle}/>
        {children}
    </MapContainer>
);

export default Map;